import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardAdminService implements CanActivate {
    user: any;
    constructor(
        public auth: AuthService,
        public router: Router
    ) {
        this.user = JSON.parse(localStorage.getItem('user'));
        console.log(this.user.role);
    }

    canActivate(): boolean {
        if (this.user.role.constructor === Array) {
            console.log('array');
            if (this.user.role.indexOf('Internbruker') > -1) {
                return true;
            }
            this.router.navigate(['/noentry']);
            return false;
        } else if (this.user.role !== 'Internbruker') {
            this.router.navigate(['/noentry']);
            return false;
        } else {
            return true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-guard-admin.service.ts